export const environment = {
  production: true,
  apiUrl: '/api'
};


// export const environment = {
//   production: false,
//   apiUrl: 'http://localhost:8080'
// };
